import { useEffect } from 'react';

/**
 * Microsoft Clarity loader.
 *
 * Loads the Clarity tracker on the production domain only when a Project ID
 * is configured via REACT_APP_CLARITY_PROJECT_ID. Clarity gives us:
 *   - free session recordings (see what real visitors do)
 *   - heatmaps (click / scroll / area)
 *   - rage-click detection
 *
 * Activation:
 *   1. Create a free project at https://clarity.microsoft.com
 *   2. Copy the 10-character Project ID (e.g. `tfgz59q3l1`)
 *   3. Paste into /app/frontend/.env as
 *        REACT_APP_CLARITY_PROJECT_ID=your_project_id_here
 *   4. Restart frontend (or redeploy). Done.
 *
 * No-op when the env var is missing, so dev/preview stay clean.
 */
const ClarityLoader = () => {
  useEffect(() => {
    const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
    if (!projectId) return;
    if (typeof window === 'undefined') return;
    if (window.__clarityInjected) return;
    window.__clarityInjected = true;

    // Official Microsoft Clarity snippet, inlined verbatim so we don't
    // depend on any third-party package.
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", projectId);
  }, []);

  return null;
};

export default ClarityLoader;
